import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DeleteBuyerListMutation,
  DeleteBuyerListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import { EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../useGraphQlClient";

const deleteBuyerListMutation = graphql(`
  mutation deleteBuyerList($id: String!) {
    deleteBuyerList(id: $id)
  }
`);

export function useDeleteBuyerList(
  options?: UseMutationOptions<
    DeleteBuyerListMutation,
    unknown,
    DeleteBuyerListMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { logEvent } = useTracking();
  const { data: currentUser } = useCurrentUser();
  return useGraphQlMutation(deleteBuyerListMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      void queryClient.invalidateQueries(["supplierStatsOrganisation"]);
      void queryClient.invalidateQueries(["buyers", "buyersForSupplier"]);
      logEvent(EventNames.buyerListDeleted, {
        "List id": variables.id,
        "User email": currentUser?.email,
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
}
